import request, { REQUEST_METHODS } from '@api/Request';
import { ProfileEndpoints } from './config';
import {
  GetManageAccessUserRequestResponse,
  GetManageAccessUserResponseData,
  GetUserProfileResponse,
  SaveUserProfileRequest,
  SaveUserProfileResponse,
  UpdateUserProfileRequest,
  UpdateUserProfileResponse,
} from './types';

export default class ProfileService {
  public static readonly getManageAccessUser = async (email: string): Promise<GetManageAccessUserResponseData> => {
    const response: GetManageAccessUserRequestResponse = await request({
      url: ProfileEndpoints.getManageAccessUser(),
      method: REQUEST_METHODS.GET,
      params: { email },
    });
    return response.data ? [response.data] : [];
  };

  public static readonly getUserProfile = (): Promise<GetUserProfileResponse> =>
    request({
      url: ProfileEndpoints.getUserProfile(),
      method: REQUEST_METHODS.GET,
    });

  public static readonly saveUserProfile = (data: SaveUserProfileRequest): Promise<SaveUserProfileResponse> =>
    request({
      url: ProfileEndpoints.saveUserProfile(),
      method: REQUEST_METHODS.POST,
      data,
    });

  public static readonly updateUserProfile = (data: UpdateUserProfileRequest): Promise<UpdateUserProfileResponse> =>
    request({
      url: ProfileEndpoints.updateUserProfile(),
      method: REQUEST_METHODS.PUT,
      data,
    });
}
